import axios from "axios";

const buildHeaders = (user) => ({
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user}`
    }
})

const BASE_URL = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_VERSION;

export const fetchUserById = async (user, id) => {

    try {
        const response = await axios.get(BASE_URL + "/users/clients/" + id,
            buildHeaders(user));
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const fetchFeaturesById = async (user, id) => {

    try {
        const response = await axios.get(BASE_URL + "/users/clients/details/features/" + id,
            buildHeaders(user));
        return response.data;
    } catch (error) {
        console.error(error);
        throw error
    }
}

export const updateUserFeatures = async (user, id, data) => {

    try {
        const response = await axios.post(BASE_URL + "/users/clients/details/features/" + id,
            {
                features: data
            },
            buildHeaders(user));
        return response.data;
    } catch (error) {
        console.error(error);
    }

}



export const fetchTransactions = async (user, id, page, fetchLimit) => {

    try {
        const response = await axios.get(BASE_URL + "/users/clients/" + id + "/trades?page=" + page + "&limit=" + fetchLimit,
            buildHeaders(user));
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const fetchCashLogs = async (user, id, page, fetchLimit) => {

    try {
        const response = await axios.get(BASE_URL + "/users/clients/" + id + "/cash-logs?page=" + page + "&limit=" + fetchLimit,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user}`
                }
            });
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

export const fetchStructuredProducts = async (user, uuid, page, fetchLimit) => {

    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${uuid}/structured-products?page=${page}&limit=${fetchLimit}`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}

export const fetchFraudCheck = async (user, uuid) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${uuid}/fraud-check`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}

export const fetchUserDocuments = async (user, id) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${id}/documents`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}

export const fetchUserAgreement = async (user, id, filename) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${id}/agreements/${filename}`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}

export const fetchPartnerInformations = async (user, id) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${id}/partner`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}

export const updateUser = async (user, id, updates, is_deleted = false) => {

    try {
        const { data } = await axios.post(`${BASE_URL}/users/clients/details/update/${id}`,
            {
                ...updates,
                user_uuid: id,
                is_deleted
            },
            buildHeaders(user));
        return data;
    } catch (error) {
        console.error(error);
        throw error
    }
}

export const uploadUserRiskLevel = async (user, id, risk_level) => {
    try {
        const { data } = await axios.post(`${BASE_URL}/users/clients/${id}/risk-level`, { risk_level },
            buildHeaders(user))
        return data;
    } catch (error) {
        console.error(error)
        throw error
    }
}


export const fetchLeverageUserPositions = async (user, uuid, page, fetchLimit) => {

    try {
        const { data } = await axios.get(`${BASE_URL}/leverage/open-positions/user/${uuid}?page=${page}&limit=${fetchLimit}`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}


export const fetchPositionOpenOrders = async (user, uuid, ticker, side) => {

    try {
        const { data } = await axios.get(`${BASE_URL}/leverage/open-orders/user/${uuid}?ticker=${ticker}&side=${side}`,
            buildHeaders(user)
        );
        return data;
    } catch (error) {
        throw error
    }
}
export const fetchSwissNotice = async (user, id) => {
    try {
        const { data } = await axios.get(`${BASE_URL}/users/clients/${id}/swiss-notice`,
            buildHeaders(user)
        );
        return data.swiss_notice;
    } catch (error) {
        throw error
    }
}
